// extracted by mini-css-extract-plugin
module.exports = {"HeaderNavLinks":"style_HeaderNavLinks__17MSs","active":"style_active__38MeH"};